export default "__VITE_ASSET__5acba6c8__"